import SadFaceIcon from "components/icons/SadFaceIcon";
import type { IYouTubeVideoFieldsFragment } from "lib/fragments/__generated__/YouTubeVideoFields.generated";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

interface VideosContentProps {
  youtubeVideos: IYouTubeVideoFieldsFragment[];
}

export default function VideosContent({ youtubeVideos }: VideosContentProps) {
  const [videoIndex, setVideoIndex] = useState(0);

  if (youtubeVideos.length === 0) {
    return (
      <div className="flex h-full w-full items-center justify-center p-4 font-aeonik">
        <div className="space-y-2 text-center text-base tracking-wide text-gray-600">
          <div>
            <SadFaceIcon />
          </div>

          <FormattedMessage defaultMessage="Nenhum vídeo foi encontrado." id="msMgUQ" />
        </div>
      </div>
    );
  }

  const video = youtubeVideos[videoIndex];

  return (
    <div className="flex w-full flex-col items-start justify-center gap-4 lg:flex-row">
      <div className="relative aspect-video w-full max-w-[831px]">
        <iframe
          title={video.title}
          className="absolute left-0 top-0 h-full w-full rounded-lg"
          allowFullScreen={true}
          src={getEmbedUrl(video)}
        />
      </div>

      {youtubeVideos.length > 1 && (
        <div className="grid grid-cols-2 gap-4">
          {youtubeVideos.slice(0, 8).map((video, index) => (
            <button
              type="button"
              key={video.id}
              onClick={() => setVideoIndex(index)}
              aria-label={`Selecionar video ${video.title}`}
              className="m-0 cursor-pointer appearance-none rounded-md border-none p-0 opacity-80 hover:opacity-100"
            >
              <img
                alt={video.title}
                title={video.title}
                width={187}
                height={105}
                src={video.thumbnails.hqdefault}
                className="h-[105px] w-[187px] select-none rounded-md object-cover"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function getEmbedUrl(video: IYouTubeVideoFieldsFragment) {
  try {
    const url = new URL(video.url);
    if (url.searchParams.has("t")) {
      const startTime = url.searchParams.get("t");
      return `https://www.youtube-nocookie.com/embed/${video.id}?rel=0&start=${startTime}`;
    }
  } catch {} // eslint-disable-line
  return `https://www.youtube-nocookie.com/embed/${video.id}?rel=0`;
}
